import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { dramas, specials } from "@/mocks/dramas";
import DramaCard from "@/components/feature/DramaCard";

export default function Special() {
  const [activeId, setActiveId] = useState(specials[0].id);
  const active = specials.find((item) => item.id === activeId) ?? specials[0];
  const items = active.dramaIds
    .map((id) => dramas.find((drama) => drama.id === id))
    .filter((drama): drama is (typeof dramas)[number] => Boolean(drama));
  const otherSpecials = specials.filter((item) => item.id !== active.id);

  useEffect(() => {
    document.title = `${active.title} - 迷人的保姆相关剧集专题`;
  }, [active]);

  return (
    <div className="mx-auto w-full max-w-7xl px-4 py-6 md:px-6 lg:px-8">
      <nav className="flex flex-wrap items-center gap-1 text-xs text-foreground-500" aria-label="面包屑导航">
        <Link to="/" className="transition-colors hover:text-primary-600">
          首页
        </Link>
        <i className="ri-arrow-right-s-line"></i>
        <span className="text-foreground-800">相关剧集专题</span>
      </nav>

      <header className="mt-4">
        <h1 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">相关剧集专题</h1>
        <p className="mt-2 max-w-3xl text-sm leading-relaxed text-foreground-600">
          围绕《迷人的保姆》与相似题材，我们整理了多个主题合集，帮助你更系统地发现值得一追的影视剧。
        </p>
      </header>

      <div className="mt-5 flex flex-wrap gap-2">
        {specials.map((item) => (
          <button
            key={item.id}
            type="button"
            onClick={() => setActiveId(item.id)}
            className={`cursor-pointer whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors ${
              item.id === active.id
                ? "bg-primary-500 text-background-50"
                : "bg-background-100 text-foreground-700 hover:bg-primary-100 hover:text-primary-700"
            }`}
          >
            {item.title}
          </button>
        ))}
      </div>

      <section className="mt-5 overflow-hidden rounded-lg border border-background-200 bg-background-50">
        <div className="border-b border-background-200 bg-primary-50 p-4 md:p-6">
          <h2 className="font-heading text-xl font-semibold text-primary-800">{active.title}</h2>
          <p className="mt-2 max-w-3xl text-sm leading-relaxed text-foreground-700">{active.intro}</p>
        </div>
        <div className="p-4 md:p-6">
          <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
            {items.map((drama) => (
              <DramaCard key={drama.id} drama={drama} />
            ))}
          </div>
        </div>
      </section>

      <div className="mt-5 grid grid-cols-1 gap-5 lg:grid-cols-3">
        <section className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5 lg:col-span-2">
          <h2 className="flex items-center gap-2 font-heading text-lg font-semibold text-foreground-950">
            <i className="ri-lightbulb-line text-accent-600"></i>
            推荐理由
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-700">{active.reason}</p>
        </section>

        <aside className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5 lg:col-span-1">
          <h2 className="flex items-center gap-2 font-heading text-lg font-semibold text-foreground-950">
            <i className="ri-links-line text-primary-500"></i>
            其他专题
          </h2>
          <ul className="mt-3 flex flex-col gap-2">
            {otherSpecials.map((item) => (
              <li key={item.id}>
                <button
                  type="button"
                  onClick={() => setActiveId(item.id)}
                  className="flex w-full cursor-pointer items-center justify-between gap-2 rounded-md bg-background-100 px-3 py-3 text-left transition-colors hover:bg-primary-50"
                >
                  <span className="min-w-0">
                    <span className="block truncate text-sm font-medium text-foreground-900">{item.title}</span>
                    <span className="mt-0.5 block truncate text-[11px] text-foreground-500">
                      收录 {item.dramaIds.length} 部剧集
                    </span>
                  </span>
                  <i className="ri-arrow-right-s-line shrink-0 text-foreground-400"></i>
                </button>
              </li>
            ))}
          </ul>
        </aside>
      </div>
    </div>
  );
}